export default __webpack_public_path__ + "static/media/edit.34b3cc5a.svg";